<template> 
    <div  class="notification-container animated fadeIn" v-if="show">
      <!-- Don't miss out on any replies! Allow push notifications? -->
      
      {{$t('notification_text')}}
      <div class="btn-container">
          <span v-on:click="askForApproval(true)" class="btn-left" role="button" tabindex="0" data-ember-action="" data-ember-action-374="374">
              Yes
          </span>
          <span v-on:click="askForApproval(false)" class="btn-right" role="button" tabindex="0" data-ember-action="" data-ember-action-375="375">
              No
          </span>
      </div>
  </div>
</template>
<script>
    import axios from 'axios';
    export default {
        data() {
            return {
                // popup: '',
                // strWindowFeatures: '',
                // URL: '',
                show: true,
            }
        },
        created: function () {
        },
        mounted: function () {
            var $self = this;
            function receiveMessage2(event){
                // console.log(event.data);
                if (typeof(event.data['permission']) !== 'undefined') {
                    if (event.data['permission']=='granted') {
                        $self.setting_noti(true);
                        $self.show = false;
                    }else{
                        $self.setting_noti(false);
                        $self.show = false;
                    }
                }
            }
            window.addEventListener("message", receiveMessage2, false);
        },
        methods: {
            askForApproval(val) {
                var $self = this;
                if (val) {

                    if (Notification.permission === "granted") {
                        console.log(1);
                        $self.setting_noti(true);
                        // $self.show = false;
                    }else{
                        var strWindowFeatures = "location=yes,height=470,width=488,scrollbars=yes,status=yes";
                        var URL = encodeURI("https://worldchatbox.worldfone.vn/webpush1.html?ref=" + location.href);
                        var popup = window.open(URL, "_blank", strWindowFeatures);
                    }

                    $self.show = false;

                    // this.createNotification('', 'created by @study.tonight', this.page.button);
                }else{
                    this.setting_noti(false);
                    this.show = false;
                }     
                

                // setTimeout(function(){ this.popup.close(); }, 3000);
                /*if(Notification.permission === "granted") {
                  createNotification('Wow! This is great', 
                   'created by @study.tonight', 
                   'https://www.studytonight.com/css/resource.v2/icons/studytonight/st-icon-dark.png');
                }else {
                    Notification.requestPermission(permission => {
                        if(permission === 'granted') {
                            createNotification('Wow! This is great', 'created by @study.tonight', 'https://www.studytonight.com/css/resource.v2/icons/studytonight/st-icon-dark.png');
                        }
                    });
                }*/
            },
            /*createNotification(title, text, icon) {
                const noti = new Notification(title, {
                    body: text,
                    icon
                });
            },*/
            setting_noti: function(val){
                window.livechat.setSettingNoti(val);
            },
        },
        watch: {
            
        },
        computed: {
            st_token () {
              return this.$store.state.st_token;
            },
            page () {
              return this.$store.state.page;
            },
        },
    }
</script>
<style scoped lang="css">
.notification-container {
    border-top: 1px solid #ebecf0;
    display: inline-block;
    font-size: .875rem;
    line-height: 1.3;
    padding: 1rem 0;
    text-align: center;
    width: 100%;
}

.notification-container .btn-container {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
 .notification-container .btn-container {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.notification-container .btn-container .btn-right, .notification-container .btn-container .btn-left {
    align-items: center;
    border: 1px solid #bcc2cb;
    border-radius: 18px;
    cursor: pointer;
    display: flex;
    height: 2.25rem;
    justify-content: center;
    margin-right: 8px;
    padding: .5rem;
    width: 6rem;
}
.notification-container .btn-container .btn-right:hover, .notification-container .btn-container .btn-left:hover {
    background-color: #707c92;
    border: 0;
    color: #fff;
}
</style>